<nb-auth-block>
    <form
        (ngSubmit)="mandaMailAdAssistenza()"
        #form="ngForm"
    >
        <h1 class="title">{{title}}</h1>   
        <p class="mb-3">Per chiedere assistenza o informazioni, utilizza il form sottostante selezionando l’argomento tra quelli
            elencati. La tua richiesta di contatto verrà inviata a chi potrà prenderla in carico adeguatamente e
            riceverai risposta per email.</p>
        <p class="mb-3">Per i <b>"Medici di MG o Ginecologi"</b> che chiedono l'abilitazione al portale: 
            Selezionare la categoria <i>"Inserimento Operatori"</i> relativo alla propria ASL/AOU di riferimento
            e ricordarsi di specificare nel messaggio il proprio Codice Fiscale, il nome e cognome e 
            la zona di operatività (Provincia o Struttura).</p>
        <div class="form-group">
            <label class="label">Inserisci la tua email per essere ricontattato</label>
            <input
                required
                type="text"
                class="form-control mb-3"
                [(ngModel)]="email"
                name="email"
                placeholder="E-mail"
            >
            <label class="label">Categoria</label>
            <select
                required
                class="form-control mb-3"
                id="categoria"
                [(ngModel)]="categoria"
                name="categoria"
            >
                <option
                    *ngFor="let c of categorie"
                    [value]="c.id"
                >{{c.nome}}</option>
            </select>
            <label class="label">Messaggio</label>
            <div class="form-group">
                <textarea
                    class="form-control"
                    rows="6"
                    required
                    [(ngModel)]="messaggio"
                    name="messaggio"
                    placeholder="Messaggio"
                ></textarea>
            </div>
            <div>
                <button
                    type="submit"
                    nbButton
                    class="btn-block"
                    [disabled]="!form.valid"
                >Invia</button><br><br>
                <button
                    (click)="back()"
                    nbButton
                    outline
                    status="warning"
                >Indietro</button>
            </div>
            <br>
        </div>

        <div class="requisiti_assistenza">
            Requisiti minimi:
            <ul>
                <li>Mozilla Firefox >= 52</li>
                <li>Chrome >= 55</li>
                <li>Microsoft Edge >= 13</li>
                <!--li>Safari >= 10</li-->
            </ul>
        </div>

    </form>


</nb-auth-block>

<ngx-spinner
    [fullScreen]="false"
    type="ball-clip-rotate-multiple"
    color="#0095ff"
    size="medium"
>
</ngx-spinner>
